var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHorn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 14.0935C6 14.0935 13 15.0935 16 18.0935H17C17.5523 18.0935 18 17.6458 18 17.0935V11.0305C18.8626 10.8085 19.5 10.0254 19.5 9.09351C19.5 8.16161 18.8626 7.37851 18 7.15651V1.09351C18 0.541226 17.5523 0.0935059 17 0.0935059H16C13 3.09351 6 4.09351 6 4.09351H2C0.89543 4.09351 0 4.98894 0 6.09351V12.0935C0 13.1981 0.89543 14.0935 2 14.0935H3L4 19.0935H6V14.0935ZM8 5.75471C8.6833 5.60811 9.5275 5.40544 10.4393 5.13724C12.1175 4.64365 14.25 3.86613 16 2.66809V15.5189C14.25 14.3209 12.1175 13.5434 10.4393 13.0498C9.5275 12.7816 8.6833 12.5789 8 12.4323V5.75471ZM2 6.09351H6V12.0935H2V6.09351Z",
    fill: "#787E82"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHorn);
export default __webpack_public_path__ + "static/media/horn.400323d596a0430b3be041efaef39553.svg";
export { ForwardRef as ReactComponent };